var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvaArrowIosBackFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7248 65.8033C30.2119 65.805 29.7051 65.6918 29.2416 65.472C28.7782 65.2522 28.3699 64.9313 28.0468 64.5329L11.4637 43.9328C10.9587 43.3184 10.6826 42.5478 10.6826 41.7526C10.6826 40.9573 10.9587 40.1867 11.4637 39.5724L28.6305 18.9722C29.2132 18.2711 30.0507 17.8302 30.9585 17.7465C31.8664 17.6628 32.7703 17.9431 33.4715 18.5259C34.1726 19.1087 34.6136 19.9461 34.6973 20.854C34.781 21.7619 34.5006 22.6658 33.9178 23.3669L18.5707 41.7698L33.4028 60.1726C33.8227 60.6765 34.0894 61.2902 34.1713 61.941C34.2533 62.5918 34.1472 63.2525 33.8655 63.8448C33.5837 64.4372 33.1382 64.9364 32.5816 65.2835C32.025 65.6306 31.3807 65.8109 30.7248 65.8033Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaArrowIosBackFill);
export default __webpack_public_path__ + "static/media/eva_arrow-ios-back-fill.b7b33120.svg";
export { ForwardRef as ReactComponent };